import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const WindowGraphics = () => {

  const servicesFaqData = [
    { 
        question: "What customisation options are available for window graphics?", 
        answer: "Printingy offers extensive customisation options for window graphics printing, including sizes, shapes, materials, and finishes. Our services include window painting design and tailored ideas to suit your branding or decor. Additional features like frosted effects, UV protection, and die-cut shapes can enhance your window graphics' functionality and aesthetic appeal."
    },
    { 
        question: "Does Printingy handle bulk orders for window graphics?", 
        answer: "Yes, Printingy specialises in bulk graphics design window printing, catering to businesses and homes with large-scale needs. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for storefront branding, promotional campaigns, and home decor projects."
    },
    { 
        question: "What industries benefit from window graphics printing services?", 
        answer: "Window graphics printing services are widely used in retail, hospitality, corporate offices, and residential spaces. Businesses rely on window graphics printing for advertising and branding, while homeowners and interior designers use our services for window painting ideas and decor. Printingy provides tailored solutions to meet the unique needs of each sector."
    },
    { 
        question: "What materials and finishes are available for window graphics?", 
        answer: "We use high-quality materials for window graphics printing, including vinyl, perforated films, and eco-friendly options. Finishes such as matte, glossy, frosted, and UV coating enhance your graphics' durability and visual appeal. These materials ensure your window graphics maintain a professional appearance while withstanding wear and environmental factors."
    },
    { 
        question: "Does Printingy provide design assistance for window graphics?", 
        answer: "Yes, our window graphics printing services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From colour schemes to border patterns, we ensure your window graphics reflect your style and purpose."
    },
    { 
        question: "What is the typical turnaround time for window graphics printing?", 
        answer: "Turnaround times for window graphics printing depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
    },
    { 
        question: "Are eco-friendly options available for window graphics printing?", 
        answer: "Yes, Printingy is committed to sustainability and offers eco-friendly options for window painting design and graphics. We use recyclable materials, non-toxic inks, and sustainable production methods to minimise environmental impact. These options are ideal for businesses and homeowners seeking environmentally responsible solutions."
    },
    { 
        question: "What factors should I consider when ordering window graphics?", 
        answer: "Consider the purpose, placement, and target audience when ordering window graphics printing. Choosing the right material, size, and design elements ensures your graphics are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your goals."
    },
    { 
        question: "How do I place an order for window graphics printing?", 
        answer: "Placing an order is simple and efficient. Visit our website and select your preferences for window graphics printing, including customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
    },
    { 
        question: "What makes bulk window graphics printing cost-effective?", 
        answer: "Bulk window graphics printing reduces per-unit costs, making it an economical choice for large-scale campaigns. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk window graphics printing services ensure exceptional value while maintaining professional standards."
    }
  ];


  const [pageTitle, setPageTitle] = useState('Window Graphics');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
       <MetaManager 
  title="Custom Window Graphics and Painting Design Printing Services"
  description="Professional window graphics printing for businesses and homes. Bulk printing of window painting designs, ideas, and window border graphics."
  keywords="Window Graphics,
Window Graphics printing,,
Window painting design,
Window painting ideas,
Graphics design window printing,
Window border printing design

"
/>
      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Custom Window Graphics Printing Services</h1>
              <h2 className="text-muted">
              Professional window painting designs and graphics for branding and decor
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4  shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Window graphics are a stylish and functional way to enhance spaces, whether for branding or aesthetic purposes. Printingy specialises in window graphics printing, offering customised solutions for window painting designs and graphics design window printing tailored to your needs.
          </p>
          
          <p>
          Our services cater to businesses and homes, providing durable and vibrant prints for promotional, decorative, or privacy purposes. From creative window painting ideas to precise window border printing designs, we ensure every detail reflects your vision and style.
          </p>
          <p>With bulk printing options and advanced printing technology, Printingy guarantees consistent quality and timely delivery. Trust us for reliable and cost-effective window graphics solutions that elevate your space.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Durable Window Graphics Printing</h2>
                <h3 className="large-hed">High-quality, customisable, and affordable window graphics and painting designs</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert window graphics printing for unique branding and decor.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Creative window painting design and ideas tailored to your style.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk graphics design window printing for cost-effective solutions.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials and UV-resistant finishes for long-lasting use.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and non-toxic printing practices.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for vibrant colours and sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.


                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by retailers, event organisers, and corporate clients nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/windowgraphics.jpg" // Path relative to the public folder
                  alt="Window painting design and printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Window Graphics Delivered On Time</h2>
            <h3 className="small-hed">Focus on your vision while we manage your window graphics printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional window graphics printing services. Whether you need window painting design for a storefront or window border printing designs for a residential project, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes guarantee timely delivery, even for large orders. Partner with Printingy for professional window graphics that make a lasting impression.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default WindowGraphics;
